import React from 'react';

import { Button, Modal } from '@social-solutions/component-library';
import { Trans } from 'react-i18next';
import theme from 'theme';
import {
    ButtonGroupWrapper,
    ButtonWrapper,
    CancelButton,
    Message,
    ModalBodyWrapper,
    SpanColor,
} from './DeleteConfigModal.styles';

interface IDeleteConfigModalProps {
  closeModal: () => void;
  saveData: () => void;
}

const DeleteConfigModal = ({
    closeModal,
    saveData,
}: IDeleteConfigModalProps): React.ReactElement => {
    return (
        <Modal
            ariaHideApp={false}
            blackout={false}
            isOpen
            onRequestClose={closeModal}
            withClose={false}
            title='Are you sure?'
            titleStyle={{ paddingLeft: '20px', paddingRight: '20px', color: theme.darkGrey }}
        >
            <ModalBodyWrapper>
                <Message>
                    <Trans>SAML.DELETE_WARNING_PART_1</Trans> <SpanColor><Trans>SAML.DELETE_WARNING_PART_2</Trans></SpanColor> <Trans>SAML.DELETE_WARNING_PART_3</Trans>
                </Message>
                <ButtonGroupWrapper>
                    <ButtonWrapper>
                        <CancelButton onClick={closeModal}><Trans>BUTTON.LABEL_CANCEL</Trans></CancelButton>
                    </ButtonWrapper>
                    <ButtonWrapper>
                        <Button onClick={saveData}><Trans>BUTTON.LABEL_CONTINUE</Trans></Button>
                    </ButtonWrapper>
                </ButtonGroupWrapper>
            </ModalBodyWrapper>
        </Modal>
    );
};

export default DeleteConfigModal;
